import { Space as SpaceAntd } from 'antd';
import cn from 'classnames';
import type { ComponentProps } from 'react';
import { type SizeValue, useGetSize } from './hooks';
import styles from './space.module.css';

type P = {
  block?: boolean;
  size?: SizeValue;
} & Omit<SpaceAntdProperties, 'size'>;

type SpaceAntdProperties = ComponentProps<typeof SpaceAntd>;

const Space = ({ block, className, size, ...rest }: P) => {
  const resolvedSize = useGetSize({ size });

  return (
    <SpaceAntd
      className={cn(className, styles.space, { [styles['space--block'] ?? '']: block })}
      size={resolvedSize}
      {...rest}
    />
  );
};

export default Space;
